var map = {
	"./404.svg": "sEM+",
	"./cases.svg": "fkzu",
	"./database.svg": "T380",
	"./edit.svg": "ql+d",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./filter.svg": "ObMl",
	"./home.svg": "U9Ws",
	"./icon.svg": "vUvT",
	"./language.svg": "+Dip",
	"./order.svg": "gYtG",
	"./page.svg": "zrC5",
	"./password.svg": "QjmH",
	"./search.svg": "Bx0U",
	"./setting.svg": "Kttn",
	"./star.svg": "60zo",
	"./tab.svg": "Jysk",
	"./user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 77